export default __webpack_public_path__ + "static/media/ExclusivoClosed.1b2b9ae1.jpg";